export const appConstants = {
    SHOW_VERSION_CHECK_MODAL: "APP_SHOW_VERSION_CHECK_MODAL",
    HIDE_VERSION_CHECK_MODAL: "APP_HIDE_VERSION_CHECK_MODAL",
    BUILD_INFO_RECEIVED: "APP_BUILD_INFO_RECEIVED",
};
